import { db, storage } from "./firebaseServices";

import { collection, getDocs, query, where } from "firebase/firestore";
import { ref, listAll, getDownloadURL } from "firebase/storage";

export const getCategories = async () => {
  const categoriesCollection = collection(db, "categories");
  const snapshot = await getDocs(categoriesCollection);
  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};

export const getCategoryImages = async (categoryId) => {
  console.log("Category ID sent to Firestore1:", categoryId, typeof categoryId);
  const imagesCollection = collection(db, "images");
  const q = query(imagesCollection, where("categoryId", "==", categoryId));
  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};

export const getCategoryProducts = async (categoryId) => {
  try {
    const productsRef = collection(db, "products");
    const q = query(productsRef, where("category", "==", categoryId));
    const querySnapshot = await getDocs(q);

    const products = querySnapshot.docs.map((doc) => {
      console.log("Product data:", doc.data()); // Log each document's data
      return {
        id: doc.id,
        ...doc.data(),
      };
    });
    return products;
  } catch (error) {
    console.error("Error fetching products by category:", error);
    return [];
  }
};

export const handleProductSkuSearch = async (searchTerm) => {
  try {
    const productsCollection = collection(db, "products");
    const q = query(productsCollection, where("sku", "==", searchTerm));
    const querySnapshot = await getDocs(q);

    const productNameSearchResults = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    console.log("Search results:", productNameSearchResults);
    return productNameSearchResults;
  } catch (error) {
    console.error("Error searching products:", error);
    return [];
  }
};

export const getAllLogoUrls = async () => {
  const folderRef = ref(storage, "logos");

  try {
    const result = await listAll(folderRef);

    // Map over each item and retrieve both the URL and file name
    const urlsAndNames = await Promise.all(
      result.items.map(async (itemRef) => {
        const url = await getDownloadURL(itemRef); // Get the download URL
        const fileName = itemRef.name; // Get the file name
        const fullPath = itemRef.fullPath; // Storage path (e.g. "logos/xyz.png")
        return { url, fileName, fullPath }; // Return URL, file name and storage path
      })
    );

    console.log("Logos:", urlsAndNames);
    return urlsAndNames; // Return an array of objects with URL and file name
  } catch (error) {
    console.error("Error fetching logo URLs:", error.message, error.code);
    throw error;
  }
};
